const requests = {
    addToWaitlist: `/waitlist`,

    diagrams: `/v1/diagrams`,

    fetchDiagramsList: `/v1/diagrams`,
    fetchTemplatesList: `/v1/diagrams-templates`,

    diagramChanges: `/v1/diagrams`,
    templateChanges: `/v1/diagrams-templates`,

    invitePeople: `/v1/invite`,
    sendFeedback: `/v1/requests/feedback`,
    sendRequest: `/v1/requests`,

};

export default requests;
